import {defineField, defineType} from 'sanity'
import {FaSearch} from 'react-icons/fa'

export default defineType({
  name: 'inline-search-section',
  title: 'Inline Search Section',
  type: 'object',
  icon: FaSearch,
  fields: [
    defineField({
      name: 'title',
      type: 'string',
      validation: (Rule) => Rule.required(),
    }),
  ],
  preview: {
    select: {
      title: 'title',
    },
  },
})
